// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__fqx9H","label":"styles_label__UEsp4","value":"styles_value__PVUsQ"};